// extracted by mini-css-extract-plugin
module.exports = {"modal-warning-lbp":"ModalWarningLBP_modal-warning-lbp__3Yh1C","main":"ModalWarningLBP_main__3cZFF","description":"ModalWarningLBP_description__3IsUN"};